module.exports = __webpack_public_path__ + "static/media/tag.6b04c551.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/tag.svg
 ** module id = 147
 ** module chunks = 0
 **/